import React, { Component } from 'react';
import Map from './Map'
import "./MapContainer.css"
import { Slider, Button, Icon } from 'antd'

const sizes = {1:1, 2:4, 3:9, 4:16};
const colorLevel=[0,1,2,3,4,5,6,7,8,9,10];
const colorDict = { // 0 - 10
    0: "rgb(222, 208,223)", //0
    1: "rgb(223, 211, 215)",
    2: "rgb(241, 235, 239)",
    3: "rgb(249, 246, 241)",
    4: "rgb(243, 255, 245)",
    5: "rgb(180, 231, 214)",
    6: "rgb(153, 221, 182)",
    7: "rgb(133, 218, 197)",
    8: "rgb(79, 190, 184)",
    9: "rgb(0, 170, 183)",
    10: "rgb(1, 157, 182)", //10
}

class MapContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lng: 121.5298,
            lat: 31.2234,
            zoom: 10,
            gridSize: 4,
            geoJson: {}
        }
    }

    async componentDidMount() {
        this.geoJsonSource = {};
        // `/grid?level=${i+1}&ratio=1`
        for (let i = 1; i < 5; i++) {
            let response = await fetch(`https://engie-dhc.oss-cn-beijing.aliyuncs.com/geojson/${i}.json`);
            //https://engie-dhc.oss-cn-beijing.aliyuncs.com
            this.geoJsonSource[i] = await response.json();
        };
        this.props.onloaded();
        this.onChangeGridSize(this.state.gridSize);
    }

    componentDidUpdate(prevProps) {
        if (this.props.weights !== prevProps.weights) {
            this.updateDistibutions();
            if (JSON.stringify(this.props.features) != "{}") {
                let oldFeatures = Object.assign({}, this.props.features);
                let newFeatures = Object.assign(oldFeatures, { 'score': this.getScore(this.props.features) });
                this.props.onChangeFeatures(newFeatures);
            }
        }
    }

    updateDistibutions = () => {
        const geoJson = this.state.geoJson;
        const result = {};
        for (let key in geoJson.features[0].properties) {
            // result[key] = geoJson.features.map(x => x.properties[key])
            result[key] = geoJson.features.map(x => key == "peak load" ? x.properties[key]/1000000: x.properties[key]) // peak load unit: W --> MW
        }
        Object.assign(result, { score: geoJson.features.map(x => this.getScore(x.properties)) });
        this.props.onChangeDistributions(result);
    }

    /**
     * Grid size changed by slider
     * @param {Number} e Grid size level (negative)
     */
    onChangeGridSize = (e) => {
        let size = Math.abs(e);
        const geoJson = this.geoJsonSource[size];
        if (!(geoJson && geoJson.features && geoJson.features.length > 0)) return;
        this.setState({ gridSize: size });
        this.setState({ geoJson: geoJson }, () => {
            this.updateDistibutions();
            this.props.onChangeFeatures({});
        });

    }

    /**
     * The longtitude latitude and zoom level of map changed
     */
    onChangeMap = (lng, lat, zoom) => {
        this.setState({
            lng, lat, zoom
        })
    }

    /**
     * A cell of grid clicked (Grid mode only)
     */
    onChangeCell = (feature) => {
        if (feature) {
            feature.properties.score = this.getScore(feature.properties)
            this.props.onChangeFeatures(feature.properties);
        }
        else this.props.onChangeFeatures({});
    }

    /**
     * Polygon drawn (Lasso mode only)
     * @param {Number[][]} coords
     */
    onChangePolygon = async (coords) => {
        try {
            if (coords) {
                console.log('request', new Date());
                let coord_str = coords.map(pt => `${pt[0].toString()},${pt[1].toString()}`).join('|');
                const response = await fetch(`/lasso?polygon=${coord_str}&crs=epsg:4326&ratio=1`);
                const json = await response.json();
                console.log('updated', new Date());
                const properties = json.features[0].properties;
                properties.score = this.getScore(properties)
                this.props.onChangeFeatures(properties);
            }
            else { this.props.onChangeFeatures({}); }
        }

        catch (err) {
            console.log(err);
        }
    }

    getScore = (properties) => {
        let score;
        if (!this.props.weights['load'] && !this.props.weights['cstru']){
            score=0;
        }
        else{
            let weight_load = this.props.weights['load'] / (this.props.weights['load'] + this.props.weights['cstru']);
            let weight_cstru = this.props.weights['cstru'] / (this.props.weights['load'] + this.props.weights['cstru']);
            score = properties['load score'] * weight_load + properties['constructability score'] * weight_cstru;
        }
        return score
    }

    getToolTip = (value) => {
        return `Delimited by squares of ~${sizes[this.state.gridSize]}km²`
    }

    render() {
        return (
            <div className="MapContainer">
                <Map
                    loaded={this.props.loaded}
                    mode={this.props.mode}
                    weights={this.props.weights}
                    geoJson={this.state.geoJson}
                    lng={this.state.lng}
                    lat={this.state.lat}
                    zoom={this.state.zoom}
                    getScore={this.getScore}
                    onChangeMap={this.onChangeMap}
                    onChangeCell={this.onChangeCell}
                    onChangePolygon={this.onChangePolygon}
                />
                <div className="Info" >
                    <div>{`Longitude: ${this.state.lng} Latitude: ${this.state.lat} Zoom: ${this.state.zoom}`}</div>
                </div>

                {this.props.mode == 'grid' ? (
                    <div className="MapSlider">
                        <span className="Name">Grid Size</span>
                        <Button shape="circle" type="primary" disabled={this.state.gridSize == 4} onClick={() => this.onChangeGridSize(this.state.gridSize + 1)}><Icon type={'minus'} /></Button>
                        <Slider
                            className="Slider"
                            style={{ width: 160, margin: 15 }}
                            value={-this.state.gridSize}
                            min={-4}
                            max={-1}
                            step={1}
                            dots={true}
                            onChange={this.onChangeGridSize}
                            tipFormatter={this.getToolTip}
                        />
                        <Button shape="circle" type="primary" disabled={this.state.gridSize == 1} onClick={() => this.onChangeGridSize(this.state.gridSize - 1)} ><Icon type={'plus'} /></Button>
                        {/* <div className="Description"></div> */}
                    </div>
                ) : null}
                {this.props.mode == 'grid' ? (
                    <div className="MapColorLegend">
                        {colorLevel.map((i) => 
                            
                            <div className="ColorBlock">
                                <svg id="bbb" fill={colorDict[i]} viewBox="0 0 274.9 59.1">
                                <g id="g">
                                    <ellipse class="st0" cx="246.2" cy="29.5" rx="28.6" ry="29.5"/>
                                    <polygon class="st0" points="47.5,0.1 51.7,0.1 59,0.1 63.2,0.1 24.3,39 44.3,59 40.1,59 32.8,59 28.6,59 8.6,39 	"/>
                                    <polygon class="st0" points="38.9,0.1 42.3,0.1 3.4,39 23.4,59 20,59 0,39 	"/>
                                    <path id="body" class="st0" d="M71.8,0.1h63.3h1l88.1,0c-8.5,6.8-14,17.5-14,29.5c0,12,5.5,22.6,14,29.5h-88.1h-1H52.9l-20-20
                                        L71.8,0.1z"/>
                                </g>
                                </svg>
                                <div className="Name">{i}</div>
                            </div>
                        
                            )
                        }
                    </div>
                ) : null}
            </div>

        )
    }
}

export default MapContainer
